<div class="container-fluid main-card">
    <div class="row">
        <div class="col-12">
            <h1>
                Analyse du secteur
                <span>Choisissez une ville et analysez le marché immobilier locatif en détail</span>
            </h1>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col-lg-12">
            <div class="p-0">
                <app-ad-tabs class="tools" [favorite]="favorite" [tabs]="tabs" [path]="'/app/tools/'"></app-ad-tabs>
                <ng-container *ngIf="ready">
                    <app-ad-widgets [favorite]="favorite" (favoriteChange)="updateAd()" [tab]="tab"
                                    [link]="'/app/tools/impot'" [edit]="false" [custom]="false"></app-ad-widgets>
                </ng-container>
            </div>
        </div>
    </div>
</div>
